<template>
    <div
        @dragenter="OnDragEnter"
        @dragleave="OnDragLeave"
        @dragover.prevent
        @drop="onDrop"
        :class="isDragging ? 'uploader-dragging' : 'uploader'">

        <v-layout row>
            <v-spacer></v-spacer>
            <v-btn class="ml-0" flat icon color="white" @click="removeImage">
                <v-icon>close</v-icon>
            </v-btn>
        </v-layout>
        <div>
            <v-icon style="font-size: 40px" :color="!isDragging ? 'white' : 'grey'">cloud_upload</v-icon>
            <p>{{isDragging ? 'Large a imagem para carregar' : 'Arreste sua imagem para aqui'}}</p>
            <div v-if="image">
                <img :src="image" alt="" ref="m_img">
            </div>
            <img v-if="image_path && !image" :src="image_path" alt="">
            
            <div v-visible="!isDragging">Ou</div>
            <div class="file-input" v-visible="!isDragging">
                <label for="image_file">Escolha uma imagem</label>
                <input type="file" accept="image/*" id="image_file" @change="onInputChange">
            </div>
        </div>
        <!--<p>FilePath: {{image_path}}</p>-->

    </div>
</template>

<script>
    export default {
        name: "ImageUploader",

        data(){
            return {
                isDragging: false,
                dragCount: 0,
                file: '',
                image: '',
            }
        },

        props: ['value', 'image_path'],


        methods: {
            OnDragEnter(e){
                e.preventDefault();
                // this.consoleLog('DragEnter');

                this.dragCount++;
                this.isDragging = true;
            },
            OnDragLeave(e){
                e.preventDefault();
                // this.consoleLog('DragLeave');

                this.dragCount--;
                if(this.dragCount <= 0){
                    this.isDragging = false;
                }
            },
            removeImage(){
                this.image = null;
                this.$emit('onImageUploader', null);
            },

            onInputChange(e){
                const files = e.target.files;
                this.addFile(Array.from(files)[0]);
            },
            onDrop(e){
                e.preventDefault();
                e.stopPropagation();
                // this.consoleLog('DragDrop');

                this.isDragging = false;
                const files = e.dataTransfer.files;
                // this.consoleLog(files);

                this.addFile(Array.from(files)[0]);
            },

            addFile(file){
                if(!file) return;
                if(!file.type.match('image.*')){
                    this.consoleLog('file is not an image');
                    return;
                }
                let reader = new FileReader();

                this.file = file;

                let vm = this;
                reader.onload = (e) => {
                    vm.image = e.target.result;
                    this.$emit('onImageUploader', this.image);
                };
                reader.readAsDataURL(file);


            }
        }
    }
</script>

<style scoped>
    .uploader{
        background: dodgerblue;
        color: white;
        border: 1px  dashed white;
        padding: 10px;
        text-align: center;
        border-radius: 10px;
        font-size: 12px;
        position: relative;
    }

    .uploader-dragging {
        background: white;
        color: dodgerblue;
        border: 1px dashed dodgerblue;
        padding: 10px;
        text-align: center;
        border-radius: 10px;
        font-size: 12px;
        position: relative;
    }

    .file-input{
        width: 200px;
        margin: auto;
        height: 68px;
        position: relative;
    }

    label, input{
        background: white;
        color: dodgerblue;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        padding: 10px;
        border-radius: 4px;
        margin-top: 7px;
        cursor: pointer;
    }

    input{
        opacity: 0;
        z-index: -2;
    }

    img {
        max-height: 105px;
    }


</style>